import { Injectable } from '@angular/core';
import { TenantDetails } from 'src/app/models/tenant-details';
import { Observable } from 'rxjs';
import { FabricService } from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'tenant-resources';

@Injectable({
  providedIn: 'root'
})
export class TenantsService {

  constructor(private fabricService: FabricService) {

  }

  getTenantDetails(): Observable<TenantDetails> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_tenants_details');
  }

  getTenant(tenantId): Observable<TenantDetails> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_tenants_tenantid', {tenantId});
  }
}
